export default __webpack_public_path__ + "static/media/CircularStd-Bold.6df78868.ttf";